module.exports = __webpack_public_path__ + "static/img/1.0fa5e677.png";